import { ReviewFieldKey } from '@/app/interfaces/review-fields.types';

export const reviewFieldToAnjanaFieldMap: Record<ReviewFieldKey, string> = {
  // Identificativos
  projectName: 'projectName',
  userNameResponsible: 'NombreResponsable',
  contactEmailResponsible: 'mail',
  department: 'departamentoresponsable',
  selectedOrgCode: 'organismoresponsable',
  serviceName: 'organoDirectivoResponsable',

  // Económicos
  totalPeopleBefore: 'NumeroPuestosPre',
  groupAdministrationBefore: 'GrupoNivelPre',
  levelPositionBefore: 'DedicacionPre',
  totalPeopleAfter: 'NumeroPuestosPost',
  groupAdministrationAfter: 'GrupoNivelPost',
  levelPositionAfter: 'DedicacionPost',
  amountAffectedCitizens: 'CiudadanosAfectados',
  currentApplicationCostEstimate: 'EstimacionCosteAplicacionActual',
  currentStaffCostEstimate: 'EstimacionCostePersonalActual',
  amountAffectedOfficials: 'FuncionariosAfectados',
  economicEstimateImplementation: 'EstimacionImplantacion',
  economicEstimateAnnualMaintenance: 'EstimacionMantenimiento',
  economicEstimateConsumption: 'EstimacionConsumo',
  averageResolutionEstimateTime: 'resolucionPreIA',
  averageResolutionRealTime: 'resolucionPostIA',
  otherDerivedCosts: 'OtrosCostesDerivados',
  postDeploymentStaffCostEstimate: 'EstimacionCostePersonalPostDespliegue',

  // Datos de entrada
  personalSelectedDataType: 'datosPersonales',
  categoryDataPersonalSelected: 'categoriaDatosPersonales',
  biometricData: 'datosBiometricos',
  RAT: 'RAT',
  eipd: 'fechaEIPD',
  csvEipd: 'csvEipd',

  // Datos funcionales
  systemFinality: 'Finalidad',
  selectedProcedure: 'procedimiento',
  administrativeProcess: 'tramiteAdministrativo',
  systemOrApp: 'AplicacionesRelacionadas',
  projectClassification: 'ClasificacionAIAct',
};

export const anjanaFieldToReviewFieldMap: Record<string, ReviewFieldKey> = Object.entries(
  reviewFieldToAnjanaFieldMap
).reduce(
  (acc, [reviewFieldKey, anjanaField]) => {
    acc[anjanaField] = reviewFieldKey as ReviewFieldKey;
    return acc;
  },
  {} as Record<string, ReviewFieldKey>
);
